<template>
  <div class="hose-recommendations" :class="device">
    <grid-table :show-all="showMore"></grid-table>

    <div class="show-more" @click="showMore = !showMore">
      <span v-if="!showMore">{{ $t('hose.moreHoses') }}</span>
      <span v-if="showMore">{{ $t('hose.lessHoses') }}</span>
      <img :src="getImage('blue-down-arrow.svg')">
    </div>
    <div class="share-popup d-none d-md-flex" @click="openShareModal">
      <img src="../../assets/share.png">
      <span class="sub-title">{{ $t('general.share') }}</span>
    </div>
    <!-- Share modal -->
    <popup-share
            v-if="shareModal"
            :shareLink="shareLink"
            @close="shareModal = false"/>
  </div>
</template>

<script>
import GridTable from "@/components/hose/components/GridTableHoses";
import PopupShare from "../popup/PopupShare";
import {mapGetters} from "vuex";
import { getShareUrl } from "@/helpers/route";

export default {
  name: "HoseRecommendations",
  components: {GridTable, PopupShare},

  data() {
    return {
      showMore: false,
      shareModal: false,
      shareLink: null,
    }
  },

  computed: {
    ...mapGetters({
      device: 'getDevice',
    })
  },

  methods: {
    openShareModal() {
      this.$store.dispatch('build/hoses/getBuildId').then((buildId => {
        if (buildId) {
          this.$store.dispatch('share/open', {
            configurator: 'hose',
            uid: buildId,
            trigger: 'share-build'
          });
        } else {
          alert("Er is iets fout gegaan. Neem contact op met de helpdesk.");
        }
      }));
    }
  }
}
</script>

<style scoped lang="scss">
  .magento {
    .hose-recommendations {
      .show-more {
        margin-top: 0;
        padding-top: 10px;
        background-color: #FFF;
      }
    }
  }

  .hose-recommendations {
    background-color: #F5F5F5;
    grid-row-start: 3;
    grid-row-end: 4;
    grid-column-start: 2;
    grid-column-end: 3;
    margin-bottom: 20px;
    position: relative;

    &.mobile {
      max-width: calc(100vw - 30px);
      overflow-y: scroll;
      grid-column-start: 1;
      grid-column-end: 2;
    }

    &.tablet {
      max-width: 800px;
      overflow-y: scroll;
    }

    .show-more {
      margin-top: 10px;
      width: 100%;
      text-align: center;
      font-family: neue-haas-grotesk-text, sans-serif;
      text-decoration: underline;
      font-size: 12px;
      cursor: pointer;
      user-select: none;

      img {
        margin-left: 14px;
      }
    }

    .share-popup {
      bottom: -20px;
    }
  }
</style>
